module.exports = __webpack_public_path__ + "static/media/popup_home_280822.ae784895.svg";